._ClientBrief_uneyf_1 {
  padding-block-end: 1rem;
}